import { render, staticRenderFns } from "./PetitionEmail.vue?vue&type=template&id=182dd0aa&scoped=true&"
import script from "./PetitionEmail.vue?vue&type=script&lang=js&"
export * from "./PetitionEmail.vue?vue&type=script&lang=js&"
import style0 from "./PetitionEmail.vue?vue&type=style&index=0&id=182dd0aa&prod&lang=css&"
import style1 from "./PetitionEmail.vue?vue&type=style&index=1&id=182dd0aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182dd0aa",
  null
  
)

export default component.exports